module.exports = __webpack_public_path__ + "static/media/Edward Hartung.5a2f82c0.jpg";